import { AppConfig } from 'src/environments/appconfig';
import { catchError, map } from 'rxjs/operators';
import { JWT_RESPONSE_HEADER, TIME } from './constantes';
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UsuarioActual } from 'src/app/util/usuarioactual';
import { DtoCorreo } from './usuario.public.service';
import { UHttpsClient } from './uhttpsClient';

@Injectable()
export class SeguridadService {
  private urlPublic = `${this.config.getEnv('proxy')}publico/api`;
  private url = `${this.config.getEnv('proxy')}public/seguridad/usuario/`;
  private sid = `${this.config.getEnv('sid')}`;

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private router: Router,
    private http: UHttpsClient,
    private config: AppConfig) {
  }

public obtenerMenu(usuario:string ): Promise<any> {
  const params = new HttpParams().set('usuario', usuario)
  return this.http.get(`${this.url}obtenerMenu`, { params, headers: this.headers })        
      .toPromise()
      .then(response => response as any)
      .catch(error => new Object());
}   

public obtenerUsuarioActual(usuario:string ): Promise<UsuarioActual> {
  const params = new HttpParams().set('usuario', usuario)
  return this.http.get(`${this.url}obtenerUsuarioActual`, { params , headers: this.headers})        
      .toPromise()
      .then(response => response as any)
      .catch(error => new UsuarioActual());
} 


public enviarRecuperarClave(correo: string): Promise<any> {

  var dtoCorreo: DtoCorreo = new DtoCorreo();
  dtoCorreo.correo = correo;

  return this.http.post(`${this.url}api/Usuario/enviarRecuperarClave`, dtoCorreo ,{headers: this.headers})
      .toPromise()
      .then(response => (response as any).mensaje as string)
      .catch(error => null);
}


  // login(username: string, password: string): Promise<any> {
  //   const headers = new Headers({ 'Content-Type': 'application/json' });

  //   const ua = new UsuarioActual();
  //   ua.usuarioLogin = username;
  //   ua.clave = password;

  //   return this.config.getHttp().post(`${this.urlSeguridad}login`, ua, { headers: headers })
  //     .toPromise()
  //     .then(response => this.saveToken(response.json() as UsuarioActual))
  //     .catch(error => Promise.reject(error));
  // }

  isLoggedIn() {
    let resultado: Boolean;
    resultado = !!sessionStorage.getItem(JWT_RESPONSE_HEADER);
    return resultado;
  }


  obtenerInformacionUsuario(idCompania: string, usuario: string): Promise<UsuarioActual> {
    return this.http.get(`${this.url}/${idCompania}/${usuario}`,{ headers: this.headers}).toPromise()
      .then(response => response  as UsuarioActual);
  }

  logout(): Promise<any> {
   // const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(`${this.urlPublic}logout`, 'corpus', { headers: this.headers })
      .toPromise()
      .then(response => response as any)
      .catch(error => Promise.reject(error));
  }

  private saveToken(res: UsuarioActual): any {
    const token = res.token;
    if (token) {
      sessionStorage.setItem(JWT_RESPONSE_HEADER, token);
    }
    this.extendExpirationTime();
    return res;
  }

  extendExpirationTime() {
    sessionStorage.setItem(TIME, new Date().toString());
  }

  // usuarioCargar(file: File, usuario: UsuarioActual): Observable<HttpEvent<{}>> {
  //   const formdata: FormData = new FormData();
  //   const ruta = this.url + '/usuarioCargar';
  //   formdata.append('file', file);
  //   const req = new HttpRequest('POST', ruta, formdata, {
  //     reportProgress: true,
  //     responseType: 'text'
  //   });
  //   return this.httpCliente.request(req);
  // }
}
